import { render, staticRenderFns } from "./PageSettingsSeo.vue?vue&type=template&id=c91f2ad2&scoped=true"
import script from "./PageSettingsSeo.vue?vue&type=script&lang=js"
export * from "./PageSettingsSeo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91f2ad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c91f2ad2')) {
      api.createRecord('c91f2ad2', component.options)
    } else {
      api.reload('c91f2ad2', component.options)
    }
    module.hot.accept("./PageSettingsSeo.vue?vue&type=template&id=c91f2ad2&scoped=true", function () {
      api.rerender('c91f2ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/page/PageSettingsSeo.vue"
export default component.exports